module.exports = __webpack_public_path__ + "img/api-closed.80d88bc7.png";